import * as actionTypes from '../constants/actions';

export function listenToBrowserResize() {
	return function(dispatch) {
		let debounce = 0;
		let handleEvent = (e) => {
			debounce && clearTimeout(debounce);
			debounce = setTimeout(() => {
				dispatch(updateBrowserSize());
			}, 100);
		};

		window.addEventListener('resize', handleEvent);

		return function() {
			window.removeEventListener('resize', handleEvent);
		};
	};
}

export function updateBrowserSize() {
	return {
		type: actionTypes.BROWSER_RESIZE,
		payload: true,
	};
};



/** WEBPACK FOOTER **
 ** ./frontend/actions/browser.js
 **/